import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Alert, AlertType} from '../_models/alert';
import {MessageService} from "primeng/api";

@Injectable()
export class AlertService {
    public subject = new Subject<Alert>();
  public loadingValue = false;
  public loading = new BehaviorSubject(false);
    public keepAfterRouteChange = false;
    public suppressRootAlert = new BehaviorSubject(false);

    constructor(public router: Router, public messageService: MessageService) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.suppressRootAlert.next(false);
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;

                } else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
        this.loading.subscribe(v => {
          setTimeout(() => this.loadingValue = v);
        })
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: any, keepAfterRouteChange = false) {

        this.clear();

        this.alert(AlertType.Success, message, keepAfterRouteChange);
    }

    error(message: any, keepAfterRouteChange = false) {

        this.clear();

      let error: string = message;
      if (message.status == '401'){
          if (message._body)
          {
            error = message.json();
          }
          else {
            error = "Username or password is incorrect";
          }
        }

        this.alert(AlertType.Error, error, keepAfterRouteChange);
    }

    info(message: any, keepAfterRouteChange = false) {

        this.clear();

        this.alert(AlertType.Info, message, keepAfterRouteChange);
    }

    warn(message: any, keepAfterRouteChange = false) {

        this.clear();

        this.alert(AlertType.Warning, message, keepAfterRouteChange);
    }

    alert(type: AlertType, message: any, keepAfterRouteChange = false) {
        /*this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<Alert>{ type: type, message: message });*/
      this.messageService.add({
        severity: 'info',//type == AlertType.Error ? 'error' : type == AlertType.Info ? 'info' : type == AlertType.Success ? 'success' : 'warn',
        detail: message
      });
    }

    clear() {
        // clear alerts
        this.subject.next(null);
    }
}
